<template>
  <section class="main-container">
    <el-row class="login-container">
      <el-col :span="12" style="text-align:center;">
        产品注册升级管理系统
        <img src="../assets/RMS-logo.png" />
      </el-col>
      <el-col :span="12">
        <el-form ref="loginForm" :model="loginForm" label-width="80px" :rules="loginFormRules">
          <el-form-item label="账号：" prop="username" >
            <el-input v-model="loginForm.username" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="userpasswd">
            <el-input type="password" v-model="loginForm.userpasswd" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <slideValid :validFlag="validFlag" :mainContainer="mainContainer" v-on:change="changeValidFlag" ref="slideValid"></slideValid>
            <!-- <div id="validContainer" style="width:100%;">
              <div id="validBG"></div>
              <div id="validMoveBox" style="left:0;"><i  :class="iconStyle"></i></div>
              <div id="validTitle">拖动滑块验证</div>
            </div> -->
          </el-form-item>
          <el-form-item style="text-align:right;"><el-checkbox v-model="isRemembered">记住账号</el-checkbox></el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" style="width:100%;" v-loading="loading">登录</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="footer">
        © 2017 Copyrights groupinno
    </el-row>
  </section>
</template>
<script>
import { requestLogin } from "../api";
import slideValid from './slideValid'
import md5 from "js-md5";
export default {
  components: {
    slideValid
  },
  data() {
    return {
      loginForm: {
        username: "",
        userpasswd: ""
      },
      loginFormRules: {
        username: [{ required: true, message: "请输入账号!", trigger: "blur" }],
        userpasswd: [{ required: true, message: "请输入密码!", trigger: "blur" }]
      },
      isRemembered: true,
      validFlag: false,
      mainContainer: document.getElementsByClassName('main-container')[0],
      loading:false,
      validMoveBox: "",
      validBG: "",
      validContainer: "",
      validTitle: "",
      iconStyle:'el-icon-d-arrow-right'
    };
  },
  methods: {
    changeValidFlag(flag){
      this.validFlag = flag;
    },
    onSubmit() {
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          if (!this.validFlag) {
            this.$message({
              message: "请拖动滑块进行验证",
              type: "warning"
            });
            return;
          }
          this.loading = true;
          let param = {
            username: this.loginForm.username,
            userpasswd: md5(this.loginForm.userpasswd)
          };
          requestLogin(JSON.stringify(param))
            .then(res => {
              this.loading = false;
              if (res.code == 200) {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                sessionStorage.setItem("username", this.loginForm.username);
                if (this.isRemembered) {
                  localStorage.setItem("username", this.loginForm.username);
                } else {
                  localStorage.removeItem("username");
                }
                this.$router.push({ path: "/customer" });
              } else {
                this.$message({
                  message: "账号或者密码错误！",
                  type: "error"
                });
                //调用子方法，初始化
                this.$refs.slideValid.initSlide();
              }
            })
            .catch(res => {
              this.$message({
                  message: "服务器错误，请联系系统管理员！",
                  type: "error"
                });
              this.loading = false;
            });
        } else {
          console.log("存在必填项未通过检验");
        }
      });
    },
    slideValid1() {
      this.validContainer = document.getElementById("validContainer");
      this.validMoveBox = document.getElementById("validMoveBox");
      this.validBG = document.getElementById("validBG");
      this.validTitle = document.getElementById("validTitle");
      this.mainContainer = document.getElementsByClassName("main-container")[0];
      this.validMoveBox.style.left = "0";
      this.validBG.style.width = "0";
      this.iconStyle = 'el-icon-d-arrow-right'
      this.validFlag = false;
      this.validMoveBox.onmousedown = e => {
        var mouseDownx = e.clientX;
        this.mainContainer.onmousemove = (e) => {
          var moveX = e.clientX - mouseDownx;
          if (moveX < 0) {
            return;
          }
          this.validMoveBox.style.left = moveX + "px";
          this.validBG.style.width = moveX + "px";

          if (moveX >= this.validContainer.offsetWidth - 42) {
            this.mainContainer.onmousemove = e => {
              this.validMoveBox.style.left = this.validContainer.offsetWidth - 42 + "px";
              this.validBG.style.width = this.validContainer.offsetWidth - 42 + "px";
              this.validTitle.style.color = "#fff";
              this.validTitle.innerText = "验证通过";
              this.validMoveBox.onmousedown = null;
              this.mainContainer.onmousemove = null;
              this.validFlag = true;
              this.iconStyle = 'el-icon-success'
            };
          }
        };
      };
      this.validMoveBox.onmouseup = e => {
        var left = this.validMoveBox.style.left.split("px")[0];
        if (left < this.validContainer.offsetWidth - 42) {
          this.validMoveBox.style.left = "0";
          this.validBG.style.width = "0";
        }
        this.mainContainer.onmousemove = null;
      };
    }
  },
  mounted() {
    this.loginForm.username = localStorage.getItem("username");
    this.mainContainer = document.getElementsByClassName('main-container')[0];
    // this.slideValid();
  }
};
</script>

<style scoped lang="less">
.main-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -moz-user-select:none;
  -webkit-user-select:none;
  user-select:none;  
}
.login-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  #validContainer {
    position: relative;
    background-color: #ddd;
    border-radius: 5px;
    height: 40px;
    #validBG {
      position: absolute;
      background-color: #7ac23c;
      border-radius: 5px;
      height: 40px;
    }
    #validTitle {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
    #validMoveBox {
      position: absolute;
      background-color: #fff;
      width: 40px;
      height: 38px;
      border: 1px solid #aaa;
      text-align: center;
      cursor: move;
      z-index: 9999;
      .el-icon-success{
        color:#7ac23c;
      }
    }
  }
}
.footer {
  width: 90%;
  position: absolute;
  bottom: 1%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue